import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 保存图片到本地相册; 比如保存二维码.接口请求参数
 */
export type FabricPhotoSaveImageToPhotosAlbumOptions = {
  /**
   * 当前图片类型, 网络图片, 本地图片, base64
   */
  type: 'http' | 'local' | 'base64';
  /**
   * 图片文件路径，可以是临时文件路径或永久文件路径 (本地路径) ，或者网络路径 或者 文件数据(base64),
   */
  filePath: string;
};

/**
 * 保存图片到本地相册后的返回路径, 可以是本地的虚拟路径, 此路径可以预览接口一样
 * 可以进行上传, 访问 `previewImage`访问
 */
export type FabricPhotoSaveImageToPhotosAlbumCallbackData = {
  /**
   * 图片保存后的本地路径.
   */
  filePath: string;
};

export type FabricPhotoSaveImageToPhotosAlbumApi = (
  options: FabricPhotoSaveImageToPhotosAlbumOptions
) => Promise<FabricPhotoSaveImageToPhotosAlbumCallbackData>;

/**
 * 保存图片到本地相册; 比如保存二维码.
 */
export const saveImageToPhotosAlbum: FabricPhotoSaveImageToPhotosAlbumApi = (
  options: FabricPhotoSaveImageToPhotosAlbumOptions
): Promise<FabricPhotoSaveImageToPhotosAlbumCallbackData> => {
  return new Promise<FabricPhotoSaveImageToPhotosAlbumCallbackData>(
    (resolve, reject) => {
      core.call<
        'fabric_photo.saveImageToPhotosAlbum',
        FabricPhotoSaveImageToPhotosAlbumOptions,
        FabricPhotoSaveImageToPhotosAlbumCallbackData
      >('fabric_photo.saveImageToPhotosAlbum', options, (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      });
    }
  );
};
